<template>
    <v-layout align-center justify-center>
    <v-flex xs12 sm8 md8 lg7 xl4>
        <v-tabs v-model="active" color="green darken-4" dark slider-color="orange lighten-2" grow>
            <v-tab disabled :key="question.id" v-for="question in questions">
                {{ question.id }}
            </v-tab>
            <v-tabs-items :touchless="true">
            <v-tab-item :key="question.id" v-for="question in questions">    

                <v-list v-if="question.type == 'radio'" two-line>
                    <p class="headline question">{{ question.question }}<p class="caption smalltext"> (Valitse yksi annetuista vaihtoehdoista)</p></p>

                    <v-divider></v-divider>
                    <template v-for="(answer, index) in question.answers">
                        <v-list-tile v-bind:class="isSelected(question, answer)"  @click="selectAnswer(question, answer)" :key="answer.id" >
                            
                                    {{ answer.text }}
    
                        </v-list-tile>
                        <v-divider v-if="index + 1 < question.answers.length" :key="`divider-${index}`"></v-divider>                              
                    </template>
                    <v-layout class="text-cs-center" mt-3>
                        <v-flex xs6>
                            <v-btn  block v-if="active > 0" @click="previous">Edellinen kysymys</v-btn>
                        </v-flex>
                        <v-flex>
                            <v-btn color="#1b5e1f" class="white--text" block v-if="active < 4" @click="next" >Seuraava kysymys</v-btn>
                            <v-btn color="#1b5e1f" class="white--text" block v-else @click.native="showResults" @click="showResults" >Tulokset</v-btn>
                        </v-flex>
                    </v-layout>
                  
                </v-list>

                <v-card v-if="question.type == 'slider'">
                    <p class="headline question">{{ question.question }}<p class="caption smalltext"> (Valitse sopiva vaihtoehto liukuvalikosta)</p> </p>
                    <v-card-text>

                        <v-slider track-color="orange lighten-2"  thumb-label="always" :tick-labels="setLabels(question)" @input="updatedSlider(question, sliderValue)" v-model="sliderValue" step="1" :min="question.answers[0].points" :max="question.answers[1].points" color="orange lighten-2">
                          <template slot="thumb-label" slot-scope="props">
                            <span></span>
                          </template> 
                        </v-slider>

                    </v-card-text>

                    <v-layout class="text-cs-center" mt-3>
                        <v-flex xs6>
                            <v-btn  block v-if="active > 0"  @click="previous">Edellinen kysymys</v-btn>
                        </v-flex>
                        <v-flex>
                            <v-btn color="#1b5e1f" class="white--text" block v-if="active < 4" @click="next" >Seuraava kysymys</v-btn>
                            <v-btn color="#1b5e1f" class="white--text" block v-else @click.native="showResults" @click="showResults" >Tulokset</v-btn>
                        </v-flex>
                    </v-layout>
                </v-card>
            </v-tab-item>
            </v-tabs-items>
        </v-tabs>
    </v-flex>
    <v-snackbar top v-model="snackbar">
      Valitse yksi vaihtoehdoista!
      <v-btn
        color="#87be23"
        flat
        @click="snackbar = false"
      >
        Sulje
      </v-btn>
    </v-snackbar>
    </v-layout>
</template>

<script>
import { mapState } from "vuex";

export default {
  name: "Question",

  data: function() {
    return {
      selectedAnswer: null,
      active: 0,
      sliderValue: 3,
      snackbar: false
    };
  },

  computed: {
    ...mapState("metsanomistaja", ["stage", "questions", "currentAnswers"])
  },
  methods: {
    showResults() {
      const active = parseInt(this.active);
      if(this.currentAnswers.find((a) => a.question.id === active+1)) {
        this.$store.dispatch("metsanomistaja/showResults", {
          router: this.$router
        });
      } else {
        this.snackbar = true;
      }


    },
    previous() {
      const active = parseInt(this.active);
      this.active = active > 0 ? active - 1 : 4;
    },
    next() {
     
      const active = parseInt(this.active);

      if(this.questions[active+1].type === 'slider') {
        this.updatedSlider(this.questions[active+1], this.sliderValue)
      }

      if(this.currentAnswers.find((a) => a.question.id === active+1)) {
        
         this.active = active < 4 ? active + 1 : 0;
      } else {
        this.snackbar = true;
      }
      
    },
    selectAnswer(question, answer) {
      this.$store.dispatch("metsanomistaja/addAnswer", { question, answer });
      //this.next();
    },
    isSelected(question, answer) {
      if (
        this.currentAnswers.find(a => {
          return a.question.id === question.id && a.answer.id === answer.id;
        })
      ) {
        return ["selected-answer"];
      }
      return [];
    },
    updatedSlider(q, sliderval) {
      this.$store.dispatch("metsanomistaja/addAnswer", {
        question: q,
        answer: { id: "slider", points: sliderval }
      });
    },
    setLabels(q) {
      return [q.answers[0].text, '', 'En luovu, enkä osta', '' , q.answers[1].text]
    }
  },
  mounted() {}
};
</script>

<style>
.align-slider-text {
  float: right;
  margin-right: 15px;
}

.question {
  margin-left: 16px;
}

.smalltext {
  margin-left: 16px;
}

p.headline.question {
  margin-bottom: 0;
}

div > div.v-card__text > div > div > div.v-input__slot > div > div.v-slider__thumb-container.v-slider__thumb-container--show-label > div.v-slider__thumb-label__container > div.v-slider__thumb-label {
  background-color: #ffb74d !important;
}

.theme--light.v-input--slider:not(.v-input--is-dirty) .v-slider__thumb {
  background-color: #ffb74d !important;
  border-color: #ffb74d;
}

#app > div > main > div > div > div > div > div > div.v-tabs__bar.theme--dark.green.darken-4 > div > div > div > div {
  color: white;
}
</style>